import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClrCommonFormsModule, ClrIconModule } from "@clr/angular";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import {DatePipe, NgIf} from "@angular/common";
import { TransportStoreService } from "../../../../_shared/services";

import {environment as env} from "../../../../../environments/environment";
import {ClarityIcons, exclamationCircleIcon, floppyIcon} from "@cds/core/icon";

@Component({
  selector: 'app-order-transport-edit-positions',
  standalone: true,
  imports: [
    ClrCommonFormsModule,
    ReactiveFormsModule,
    NgIf,
    ClrIconModule
  ],
  templateUrl: './order-transport-edit-positions.component.html',
  styleUrl: './order-transport-edit-positions.component.sass'
})
export class OrderTransportEditPositionsComponent {
  public editTransportForm!: FormGroup;
  positions: any; // PositionsList[] = [];
  loading = false;

  @Input() projectId: string = '';
  @Input() transportId: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter();

  devMode: boolean;

  constructor(
    private transss: TransportStoreService,
    private fb: FormBuilder,
    private datePipe: DatePipe,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(floppyIcon, exclamationCircleIcon)
  }

  ngOnInit() {
    this.loadTransportPosition(this.projectId, this.transportId, this.editPosition, this.editPart);
  }

  initForm() {
    if (this.editTransportForm) {
      return;
    }

    this.editTransportForm = this.fb.group({
      comment_phm: [this.positions[0].comment_phm],
      controlling_nr: [this.positions[0].controlling_nr],
      delivery_date:  this.datePipe.transform(this.positions[0].delivery_date, 'dd.MM.yyyy'),
      description: [this.positions[0].description],
      heat_nr:  [this.positions[0].heat_nr],
      material: [this.positions[0].material],
      name: [this.positions[0].name],
      number_of_pieces: [this.positions[0].number_of_pieces],
      part: [this.editPart],
      position: [this.editPosition],
      project_id: [this.projectId],
      remarks:  [this.positions[0].remarks],
      serial_nr:   [this.positions[0].serial_nr],
      side_agreements: [this.positions[0].side_agreements],
      specification: [this.positions[0].specification],
      status:  [this.positions[0].status],
      taric: [this.positions[0].taric],
      technical_drawing: [this.positions[0].technical_drawing],
      technology: [this.positions[0].technology],
      transport_id: [this.positions[0].transport_id],
      weight: [this.positions[0].weight],
    });
  }

  loadTransportPosition(prid: string, transportid: number, posid: number, partid: number) {
    this.transss.getTransportPositions(prid, transportid, posid, partid).subscribe({
      next: data => {
        this.positions = data.object;
      },
      complete: () => {
        this.initForm();
      },
      error: () => {
        return
      }
    });
  }

  updateTransportPosition() {
    this.transss.updateTransportPosition(this.editTransportForm.value)
      .subscribe({
        next: () => {
          this.updatedPosition.emit(true);
        },
        error: () => {
          return
        }
      });
  }
}
